import { escape } from "./util.ts";
import { dedent } from "../../string.ts";
import { platform } from "../../runtime.ts";
import { isWSL, lockStdin, powershell, run, which } from "../../cli.ts";
import question from "./question.ts";
function createAppleScript(message) {
    return dedent `
        tell application (path to frontmost application as text)
            display dialog "${escape(message)}" with title "Alert" buttons {"OK"} default button "OK"
        end
        `;
}
function createPowerShellScript(message) {
    return dedent `
        Add-Type -AssemblyName PresentationFramework
        [System.Windows.MessageBox]::Show("${escape(message)}", "Alert")
        `;
}
export default async function alertInTerminal(message, options = {}) {
    if ((options === null || options === void 0 ? void 0 : options.gui) && platform() === "darwin") {
        const { code, stderr } = await run("osascript", [
            "-e",
            createAppleScript(message)
        ]);
        if (code) {
            throw new Error(stderr);
        }
    }
    else if ((options === null || options === void 0 ? void 0 : options.gui) && (platform() === "windows" || isWSL())) {
        const { code, stderr } = await powershell(createPowerShellScript(message));
        if (code) {
            throw new Error(stderr);
        }
    }
    else if ((options === null || options === void 0 ? void 0 : options.gui) && (platform() === "linux" || await which("zenity"))) {
        const args = [
            "--info",
            "--title", "Alert",
            "--width", "365",
        ];
        if (message) {
            args.push("--text", message);
        }
        const { code, stderr } = await run("zenity", args);
        if (code && code !== 1) {
            throw new Error(stderr);
        }
    }
    else {
        await lockStdin(() => question(message + " [Enter] "));
    }
}
//# sourceMappingURL=alert.js.map